import React from 'react';

const EditSvg = (props: {[key: string]: any}) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
        <path d="M149.996 0C67.157 0 .001 67.161.001 149.997S67.157 300 149.996 300s150.003-67.163 150.003-150.003S232.835 0 149.996 0zm71.306 107.945l-14.247 14.247-29.001-28.999-11.002 11.002 29.001 29.001-71.132 71.126-28.999-28.996-11.002 11.002 28.999 28.999-7.088 7.088-.135-.135c-.786 1.294-2.064 2.238-3.582 2.575l-27.043 6.03c-.405.091-.817.135-1.224.135-1.476 0-2.91-.581-3.973-1.647-1.364-1.359-1.932-3.322-1.512-5.203l6.027-27.035c.34-1.517 1.286-2.798 2.578-3.582l-.137-.137L192.3 78.941c1.678-1.675 4.404-1.675 6.082.005l22.922 22.917c1.678 1.678 1.678 4.404-.002 6.082z"/>
    </svg>
);

export default EditSvg;
